import { axiosPatch } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import type { z } from 'zod';
import { UpdatePasswordSchema } from '../_models/password';

export const useUpdatePassword = () => {
  return useMutation({
    mutationFn: async (values: z.infer<typeof UpdatePasswordSchema>) => {
      const { confirmPassword, ...payload } =
        UpdatePasswordSchema.parse(values);
      return await axiosPatch('/api/users/settings/password/', payload);
    },
  });
};
